import axios from 'axios';
import Cookies from 'js-cookie';
const { env } = process;
const { sesokoBaseUrl } = env;
const httpClient = axios.create({
    baseURL: `${sesokoBaseUrl}`,
    headers: { 'Content-Type': 'application/json' },
    responseType: 'json'
});
httpClient.interceptors.request.use((request) => {
    const token = Cookies.get('tmp_access_token');
    if (token) {
        request.headers.Authorization = token;
        return request;
    }
    return request;
}, function (error) {
    return Promise.reject(error);
});
httpClient.interceptors.response.use((response) => {
    return response;
});
export { httpClient };
